import React from 'react';
import './RegistrationSuccessPage.scss';
import { RegistrationSuccessViewProps } from './registrationsuccesspage.props';

const RegistrationSuccessPageView: React.FC<RegistrationSuccessViewProps> = ({
  loading, error, registration, raceName, raceTypeName, onNavigateHome,
}) => {
  if (loading) {
    return (
      <div className="registration-success-page">
        <div className="container">
          <div className="success-card">
            <div className="pending-icon">⏳</div>
            <h1>Потврдување на плаќањето...</h1>
            <p>Ве молиме почекајте додека ја обработуваме вашата регистрација.</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !registration) {
    return (
      <div className="registration-success-page">
        <div className="container">
          <div className="success-card">
            <h1>Грешка</h1>
            <p>{error || 'Регистрацијата не е пронајдена.'}</p>
            <button onClick={onNavigateHome} className="btn primary">
              Назад кон почетна
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="registration-success-page">
      <div className="container">
        <div className="success-card">
          <div className="success-icon">✓</div>
          <h1>Плаќањето е успешно!</h1>
          <p>Вашата регистрација е потврдена и плаќањето е примено.</p>

          <div className="registration-details">
            <div className="detail-row">
              <span className="detail-label">Учесник</span>
              <span className="detail-value">{registration.firstName} {registration.lastName}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Email</span>
              <span className="detail-value">{registration.email}</span>
            </div>
            {registration.phone && (
              <div className="detail-row">
                <span className="detail-label">Телефон</span>
                <span className="detail-value">{registration.phone}</span>
              </div>
            )}
            {registration.emergencyContactPhone && (
              <div className="detail-row">
                <span className="detail-label">Итен контакт</span>
                <span className="detail-value">{registration.emergencyContactPhone}</span>
              </div>
            )}
            {registration.city && (
              <div className="detail-row">
                <span className="detail-label">Град</span>
                <span className="detail-value">{registration.city}</span>
              </div>
            )}
            {registration.country && (
              <div className="detail-row">
                <span className="detail-label">Држава</span>
                <span className="detail-value">{registration.country}</span>
              </div>
            )}
            {registration.gender && (
              <div className="detail-row">
                <span className="detail-label">Пол</span>
                <span className="detail-value">{registration.gender}</span>
              </div>
            )}
            {registration.dateOfBirth && (
              <div className="detail-row">
                <span className="detail-label">Датум на раѓање</span>
                <span className="detail-value">{new Date(registration.dateOfBirth).toLocaleDateString('mk-MK')}</span>
              </div>
            )}
            {raceName && (
              <div className="detail-row">
                <span className="detail-label">Трка</span>
                <span className="detail-value">{raceName}</span>
              </div>
            )}
            {raceTypeName && (
              <div className="detail-row">
                <span className="detail-label">Тип</span>
                <span className="detail-value">{raceTypeName}</span>
              </div>
            )}
            {registration.participantType && (
              <div className="detail-row">
                <span className="detail-label">Тип на учесник</span>
                <span className="detail-value">{registration.participantType}</span>
              </div>
            )}
            {registration.teamName && (
              <div className="detail-row">
                <span className="detail-label">Име на тим</span>
                <span className="detail-value">{registration.teamName}</span>
              </div>
            )}
            {registration.tshirtSize && (
              <div className="detail-row">
                <span className="detail-label">Маичка</span>
                <span className="detail-value">{registration.tshirtSize}</span>
              </div>
            )}
            {registration.discountCode && (
              <div className="detail-row">
                <span className="detail-label">Код за попуст</span>
                <span className="detail-value highlight">{registration.discountCode}</span>
              </div>
            )}
            {registration.bibNumber && (
              <div className="detail-row bib-number">
                <span className="detail-label">Стартен број</span>
                <span className="detail-value highlight">#{registration.bibNumber}</span>
              </div>
            )}
            <div className="detail-row">
              <span className="detail-label">Плаќање</span>
              <span className="detail-value status paid">Платено</span>
            </div>
          </div>

          <p className="email-notice">
            Е-пошта за потврда со вашиот стартен број е испратена на <strong>{registration.email}</strong>
          </p>

          <button onClick={onNavigateHome} className="btn primary">
            Назад кон почетна
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccessPageView;
